import { MouseEvent } from "react"
import { css } from "@emotion/react"
import { PHOTO_RESOURCE_BASE_URL} from "config"
import { BREAK_POINT_PHONE_TAB } from "style"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper"
import 'swiper/css'
import 'swiper/css/pagination'
import { ArticleWithPhoto } from "type"
import { AiOutlineEdit } from "react-icons/ai"
import { ArticleVideoItem } from "./component/ArticleVideItem/intex"

type Props = {
  articleWithPhoto: ArticleWithPhoto
  onEditButtonClick?: (e: MouseEvent, id: string)=>void
  isShowEdit?: boolean
}

export const Article = ({
  isShowEdit = true,
  ...props
}: Props)=>{
  const date = new Date(props.articleWithPhoto.article.createdAt)

  const onEditButtonClickWrapper = (e: MouseEvent)=>{
    if (props.onEditButtonClick)
      props.onEditButtonClick(e, props.articleWithPhoto.article.id.toString())
  }

  const photoElement = props.articleWithPhoto.photos.map( photo =>{
    return(
      photo.type === 'image' ?(
        <SwiperSlide key={photo.filename}>
          <div css={imgContainerCss}>
            <img css={imgCss} src={ PHOTO_RESOURCE_BASE_URL+ '/' + photo.filename} alt="写真1" loading="lazy"/>
          </div>
        </SwiperSlide>
      ):(
        <SwiperSlide key={photo.filename}>
          <ArticleVideoItem
            photo={photo}
          />
        </SwiperSlide>
      )
    )})

  return(
    <article css={articleContainerCss}>
      <Swiper
        modules={[Pagination]}
        pagination={{dynamicBullets: true, renderBullet: customRenderBullet}}
      >
        {photoElement}
      </Swiper>
      <div css={articleInfoContainer}>
        <div css={articleBarCss}>
          <div css={articleDateContainerCss}>
            <p css={pCss}>
              {` ${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`}
            </p>
          </div>
          {
            isShowEdit && (
              <div css={articleIconCss}>
                <AiOutlineEdit onClick={onEditButtonClickWrapper}/>
              </div>
            )
          }
        </div>
        <div css={articleMessageCss}>
          <p css={pCss2}>
            {props.articleWithPhoto.article.message}
          </p>
        </div>
      </div>
    </article>
  )
}

const customRenderBullet = (index: number, className : string) => {
  return `<span class="${className}" style="background-color: black;"></span>`;
}

const articleContainerCss=css`
  display: block;
  background-color: #fff;
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
`

const imgContainerCss=css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px) {
    height: 700px;
  }
  overflow: hidden;
`

const imgCss = css`
  max-width: 100%;
  max-height: 350px;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px){
    max-height: 700px;
  }
  object-fit: cover;
  display: block;
  margin: 0;
`

const articleInfoContainer = css`
  padding: 0 1.5rem;
`

const articleBarCss = css`
  display: flex;
  margin-top: 0.5rem;
`

const articleDateContainerCss = css`
  font-size: 1rem;
`

const articleIconCss = css`
  display: flex;
  justify-content: flex-end;
  margin-left: 5rem;
  flex-grow: 1;
  font-size: 1.5rem;
`

const articleMessageCss = css`
  margin-top: 1rem;
`

const pCss = css`
  padding: 0;
`

const pCss2 = css`
  margin-top: 0px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px) {
    font-size: 30px;
  }
`